<template lang="pug">
  .consultation--base-data
    template(v-for="(location, i) in locations")
      location(
        v-if="locId === i"
        is-location
        :key="`${ title }-${ i }`"
        :ref="`location-${ i }`"
        :categories="location.categories"
        :location-name="location.name"
        @add-group="(id) => $emit('add-group', id)"
        @del-group="(field_id, id) => $emit('del-group', field_id, id)"
        @update="(id, v) => $emit('update', id, v)"
        @open-field="onOpenField"
      )

    location(
      v-if="locId === locations.length"
      :ref="`location-${ locations.length }`"
      :categories="generalCategories"
      @add-group="(id) => $emit('add-group', id)"
      @del-group="(field_id, id) => $emit('del-group', field_id, id)"
      @update="(id, v) => $emit('update', id, v)"
      @open-field="onOpenField"
    )

    v-row.sticky-footer.mt-6
      v-col.pt-0(cols="12"): hr
      v-col.d-flex.flex-column.justify-start(sm="6")
        template(v-if="prevSection")
          a.nav-location(@click="onNextLocation(locId - 1)")
            i.fo.fo-arrow-left.primary--text
            span Vorheriger Abschnitt in {{ title }}

          h4.primary--text {{ prevSection }}

        template(v-else-if="prevTab")
          a.nav-location(@click="$emit('prev-tab')")
            i.fo.fo-arrow-left.primary--text
            span Vorheriger Abschnitt {{ prevTab }}

      v-col.d-flex.flex-column.align-end(sm="6")
        template(v-if="hasNextSection")
          a.nav-location(@click="onNextLocation(locId + 1)")
            span Nächster Abschnitt in {{ title }}
            i.fo.fo-arrow-right.primary--text

          h4.primary--text {{ nextSection }}

        template(v-else-if="nextTab")
          a.nav-location(@click="$emit('next-tab')")
            span Nächster Abschnitt {{ nextTab }}
            i.fo.fo-arrow-right.primary--text

</template>

<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

import FormMixin from '@/mixins/form'

@Component({
  mixins: [
    FormMixin
  ],

  components: {
    Location: () => import('./location'),
  }
})
export default class Section extends Vue {
  @Prop({ type: String, default: '' }) title
  @Prop({ type: Object, default: () => {} }) sectionData
  @Prop({ type: String, default: '' }) prevTab
  @Prop({ type: String, default: '' }) nextTab

  @Watch('title')
  onSectionChanged () {
    this.locId = 0
  }

  locId = 0

  get locations () {
    return this.sectionData.locations || []
  }

  get generalCategories () {
    return this.sectionData.general && this.sectionData.general.categories
      ? this.sectionData.general.categories
      : []
  }

  get hasNextSection () {
    if (this.locations.length === 0 || this.locId >= this.locations.length) {
      return false
    }

    if (this.locId === this.locations.length - 1 && !this.generalCategories.length) {
      return false
    }

    return true
  }

  get nextSection () {
    if (!this.hasNextSection) {
      return ''
    }

    if (this.locId === this.locations.length - 1) {
      return 'Unternehmen allgemein'
    }

    return this.locations[this.locId + 1].name
  }

  get prevSection () {
    if (this.locId === 0) {
      return ''
    }

    return this.locations[this.locId - 1].name
  }

  mounted () {
    this.locId = 0
  }

  onNextLocation (id) {
    if (id < 0 || id > this.locations.length) {
      return
    }

    this.locId = id
  }

  onOpenField (id) {
    let found = false

    const openLocation = (locIndex, field, fieldIndex) => {
      // console.log(location, locIndex, field, fieldIndex)
      this.locId = locIndex

      setTimeout(() => {
        const loc = this.$refs[`location-${ locIndex }`]
        // console.log(loc, loc.length)
        if (typeof loc === 'object' && loc.length) {
          loc[0].openPanel(field, fieldIndex)
        } else {
          loc.openPanel(field, fieldIndex)
        }
      }, 200)
    }

    this.locations.forEach((l, index) => {
      if (!found) {
        found = this.searchFieldInCategory(id, l.categories, (f, i) => openLocation(index, f, i))
      }
    })

    if (!found) {
      this.searchFieldInCategory(id, this.generalCategories, (f, i) => openLocation(this.locations.length, f, i))
    }
  }
}
</script>

<style lang="sass">
.consultation--base-data
  a.nav-location
    display: flex
    align-items: center

    &.disabled
      color: #666
      pointer-events: none

  .sticky-footer
    position: sticky
    bottom: 0
    background-color: #fff
    z-index: 9
</style>
